import Price from 'components/Common/Property/Price';
import Size from 'components/Common/Property/Size';
import React from 'react';
import { joinNotEmpty } from 'utils/functions/arrays';
import { getReplacementIfEmpty } from 'utils/functions/miscellaneous';
import { PropTypes } from 'utils/wrappers';
import classes from '../styles/BuyNowBox.module.scss';

const BuyNowBox = ({ property, className, onBuy }) => {
    const price = <Price value={property.finances.price} />;
    const size = <Size value={property.landSize} />;
    const cssClass = joinNotEmpty([classes['buy-now-box'], className], ' ');

    return (
        <div className={cssClass}>
            <div className={classes.wrapper}>
                <div className={classes['price-and-size']}>
                    <div className={classes.price}>
                        <div className={classes.value}>{getReplacementIfEmpty(price)}</div>
                        <div className={classes['below-price']}>Purchase price</div>
                    </div>
                    <div className={classes.size}>
                        <div className={classes.value}>{getReplacementIfEmpty(size)}</div>
                        <div className={classes['below-size']}>Property size</div>
                    </div>
                </div>
                <div className={classes['short-information']}>
                    <div className={classes['listing-id']}>
                        <span className={classes.name}>Listing ID:</span>
                        <span className={classes.value}>{getReplacementIfEmpty(property.listingId)}</span>
                    </div>
                </div>
            </div>
        </div>
    );
};

BuyNowBox.propTypes = {
    property: PropTypes.shape({
        listingId: PropTypes.string.isRequired,
        landSize: PropTypes.number.isRequired,
        financialTerm: PropTypes.string,
        finances: PropTypes.shape({
            price: PropTypes.number.isRequired,
            monthlyPayment: PropTypes.number.isRequired,
            processingFee: PropTypes.number.isRequired,
        }).isRequired,
        seller: PropTypes.shape({
            name: PropTypes.string,
        }),
    }).isRequired,
    className: PropTypes.string,
    onBuy: PropTypes.func.isRequired,
};

export default BuyNowBox;
